<template>
  <v-main class="login-wrapper">
    <div class="login-background"></div>
    <v-container fill-height class="justify-center align-center py-10">
      <v-fade-transition appear>
        <v-card
          width="100%"
          max-width="480"
          class="glass-login pa-8 rounded-xl elevation-24"
        >
          <!-- Logo Section -->
          <div class="d-flex flex-column align-center mb-8">
            <v-img
              :src="require('../assets/logos/frame 82.png')"
              max-width="200"
              contain
              class="mb-4"
            ></v-img>
            <h1 class="text-h4 font-weight-bold grey--text text--darken-3 mb-1">Bienvenido</h1>
            <p class="text-subtitle-1 grey--text text--darken-1">Accede a tu portal de estudiante</p>
          </div>

          <!-- Login Form -->
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="recaptcha()"
          >
            <v-row>

              <v-col cols="12">
                <v-text-field
                  v-model="inputs[0].value"
                  label="Usuario"
                  outlined
                  rounded
                  dense
                  color="#E50050"
                  class="custom-field"
                  :rules="inputs[0].rules"
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="inputs[1].value"
                  label="Contraseña"
                  outlined
                  rounded
                  dense
                  :type="showPassword ? 'text' : 'password'"
                  color="#E50050"
                  class="custom-field"
                  :rules="inputs[1].rules"
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="mt-4">
                <v-btn
                  @click="recaptcha()"
                  block
                  x-large
                  dark
                  class="premium-btn py-6 rounded-xl elevation-8"
                  :disabled="!valid"
                  :loading="loader"
                >
                  Ingresar a mi cuenta
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

          <!-- Links Section -->
          <div class="d-flex flex-column align-center mt-8">
            <v-btn
              text
              small
              color="#E50050"
              class="text-none mb-1 font-weight-medium"
              @click="olvidoPass()"
            >
              ¿Olvidaste tu contraseña?
            </v-btn>
            <v-btn
              text
              small
              class="text-none grey--text font-weight-medium"
              @click="olvidoUser()"
            >
              Recuperar mi usuario
            </v-btn>
          </div>

          <!-- Footer/Version -->
          <div class="mt-8 text-center">
            <span class="text-caption grey--text lighten-1">IEA - BCE © 2026 | V.4.1.0</span>
          </div>
        </v-card>
      </v-fade-transition>
    </v-container>
  </v-main>
</template>

<script>
// @ is an alias to /src
import MessagesRules from "../config/MessagesRules";

export default {
  name: "Login",
  data: () => ({
    valid: true,
    showPassword: false,
    inputs: [
      {
        tag: "username",
        text: "Usuario",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Usuario" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "password",
        text: "Contraseña",
        placeholder: "",
        icon: "mdi-lock",        required: true,
        value: "",
        type: "password",
        rules: [v => !!v || "Contraseña" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "web",
        text: "web",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "true",
        type: "hidden",
        counter: 0
      },
      {
        tag: "tipoUsuario",
        text: "Tipo de Usuario",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "alumno",
        type: "select",
        rules: [v => !!v || "Tipo de Usuario" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "Alumno", value: "alumno" },
          { text: "Profesor", value: "profesor" },
          { text: "Empresa", value: "empresa" },
          { text: "Operador", value: "operador" },
        ]
      },
      
    ]
  }),
  computed: {
    loader() {
      return this.$store.getters.loader;
    }
  },
  methods: {
    seguirInscripcion(){
      this.$router.push({name:'CargaArchivo'})
    },
    async recaptcha() {
      if (!this.$refs.form.validate()) return;
      this.$store.dispatch("loader", true);
      
      try {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha("login");
        if (token) {
          this.login(token);
        } else {
          this.$store.dispatch("loader", false);
        }
      } catch (error) {
        console.error("Recaptcha error:", error);
        this.$store.dispatch("loader", false);
      }
    },
    async login(token_rc) {
      // BCE: solo alumnos pueden autenticarse
      const loginUrl = "alumno/login/BCE";
      this.inputs[3].value = "alumno";

      // Clonar inputs para no modificar el estado original
      let loginData = [...this.inputs, { tag: "token_rc", value: token_rc }];

      try {
        const res = await this.$API.post({
          url: loginUrl,
          data: loginData,
          form: true
        });

        // BCE: solo alumnos
        const userPayload = {
          IDStB: res.user.IDStB,
          Nombres: res.user.Nombres,
          Apellidos: res.user.Apellidos,
          imagen: res.user.imagen,
          borrado: res.user.Borrado === "1" || res.user.alumno_mora ? "1" : "",
          tipoUsuario: "alumno",
          deudaAlumno: res.user.validarDeuda.deuda
        };
        this.$store.dispatch("tieneBadge1", res.tieneBadge1);
        this.$store.dispatch("tieneBadge2", res.tieneBadge2);
        this.$store.dispatch("tieneBadge3", res.tieneBadge3);

        this.$store.dispatch("token", res.token_type + " " + res.access_token);
        this.$store.dispatch("user", userPayload);

        await this.ensureDataLoaded();
        
        const storedCallback = localStorage.getItem('callback');
        if (storedCallback) {
          localStorage.removeItem('callback');
          this.$router.push(storedCallback);
        } else {
          this.$router.replace({ name: "Home" });
        }
      } catch (error) {
        console.error("Login error:", error);
      } finally {
        this.$store.dispatch("loader", false);
      }
    },
    async ensureDataLoaded() {
      return new Promise((resolve) => setTimeout(resolve, 500));
    },
    async olvidoPass() {
      this.$router.push({ name: "ResetPassword" });
    },
    async olvidoUser() {
      this.$router.push({ name: "RecoverUser" });
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  position: relative;
  min-height: 100vh;
  z-index: 1;
  overflow: hidden;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #f4f7f9 0%, #e9edf1 100%);
  z-index: -1;
}

.login-background::before {
  content: "";
  position: absolute;
  top: -10%;
  right: -5%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(229, 0, 80, 0.05) 0%, transparent 70%);
  border-radius: 50%;
}

.login-background::after {
  content: "";
  position: absolute;
  bottom: -5%;
  left: -5%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(157, 23, 47, 0.05) 0%, transparent 70%);
  border-radius: 50%;
}

.glass-login {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.6) !important;
  box-shadow: 0 32px 64px -16px rgba(0, 0, 0, 0.1) !important;
}

.premium-btn {
  background: linear-gradient(135deg, #E50050, #9D172F) !important;
  text-transform: none !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

.premium-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px -6px rgba(229, 0, 80, 0.4) !important;
}

.custom-field >>> .v-input__slot {
  background: white !important;
  border-radius: 12px !important;
}

.custom-field >>> fieldset {
  border-color: rgba(0,0,0,0.08) !important;
}

/* Responsive fixes */
@media (max-width: 600px) {
  .glass-login {
    padding: 24px !important;
    margin: 16px;
    box-shadow: none !important;
    border: none !important;
    background: transparent !important;
    backdrop-filter: none;
  }
  .login-background {
    background: #ffffff;
  }
}
</style>
